import { combineReducers } from "redux";

import { login } from "./login";
import { playDate1 } from "./playDate1";
import { playDate2 } from "./playDate2";
import { detailCondition } from "./detailCondition";
import { favoriteCondition } from "./favoriteCondition";
import { course } from "./course";
import { courseNames } from "./courseNames";
import { startTime } from "./startTime";
import { group } from "./group";
import { searchResult } from "./searchResult";
import { facility } from "./facility";
import { plan } from "./plan";
import { inputPlayer } from "./inputPlayer";
import { teeTimeList } from "./teeTimeList";
import { reserver } from "./reserver";
import { version } from "./version";
import { viewinfo } from "./viewinfo";
import { reserveType } from "./reserveType";
import { kaiinken } from "./kaiinken";
import { reserveCheckInfo } from "./reserveCheckInfo";
import { reserveGolfCancelInfo } from "./reserveGolfCancelInfo";
import { changeReserveNo } from "./changeReserveNo";
import { ownerChecked } from "./ownerChecked";
import { envParam } from "./envParam";
import {golfReservationCheck} from "./golfReservationCheck"
import {golfReservationSearch} from "./golfReservationSearch"
import { golfReservationList } from "./golfReservationList";

// ゴルフ1人予約
import { soloCourse } from "./golfSolo/soloCourse";
import { soloKaiinken } from "./golfSolo/soloKaiinken";
import { golfSoloSearchData } from "./golfSolo/golfSoloSearchData";
import { golfSoloTeetime } from "./golfSolo/golfSoloTeetime";
import { golfSoloReserveInfo } from "./golfSoloReserveInfo";

// RTCC
import { checkIn } from "./RTCC/checkIn";
import { checkOut } from "./RTCC/checkOut";
import { keyWord } from "./RTCC/keyWord";
import { area } from "./RTCC/area";
import { dispArea } from "./RTCC/dispArea";
import { country } from "./RTCC/country";
import { dispCountry } from "./RTCC/dispCountry";
import { city } from "./RTCC/city";
import { dispCity } from "./RTCC/dispCity";
import { roomHome } from "./RTCC/roomHome";
import { roomOverseas } from "./RTCC/roomOverseas";
import { dispRoom } from "./RTCC/dispRoom";
import { human } from "./RTCC/human";
import { dispHuman } from "./RTCC/dispHuman";
import { stayInfo } from "./RTCC/stayInfo";
import { feeInfo } from "./RTCC/feeInfo";
import { age } from "./RTCC/age";
import { searchParam } from "./RTCC/searchParam";
import { catalogFlg } from "./RTCC/catalogFlg";
import { rtccFlg } from "./RTCC/rtccFlg";
import { passportInfo } from "./RTCC/passportInfo";
import { toUserInputInfo } from "./RTCC/toUserInputInfo";
import { toUserInputConfirmInfo } from "./RTCC/toUserInputConfirmInfo";
import { inputFlightInfo } from "./RTCC/inputFlightInfo";
import { reserveInfo } from "./RTCC/reserveInfo";
import { reserveCancelInfo } from "./RTCC/reserveCancelInfo";
import { customerAge } from "./RTCC/customerAge";
import { propertyInfo } from "./RTCC/propertyInfo";

//  カタログ
import { news } from "./news";

// 会員制ホテル
import { room } from "./membership_hotel/room";
import { adultNum } from "./membership_hotel/adultNum";
import { childNum } from "./membership_hotel/childNum";
import { grade } from "./membership_hotel/grade";
import { roomDetailCriteria } from "./membership_hotel/roomDetailCriteria";
import { dispFacility } from "./membership_hotel/dispFacility";
import { dispDetailCondition } from "./membership_hotel/dispDetailCondition";
import { planConditions } from "./membership_hotel/planConditions";
import { privilegedService } from "./membership_hotel/privilegedService";
import { food } from "./membership_hotel/food";
import { membershipFacility } from "./membership_hotel/membershipFacility";
import { vacancyList } from "./membership_hotel/vacancyList";
import { vacancyFacility } from "./membership_hotel/vacancyFacility";
import { gradeData } from "./membership_hotel/gradeData";

import { right } from "./membership_hotel/right";
import { membershipReserveComf } from "./membership_hotel/membershipReserveComf";
import { mealInfoList } from "./membership_hotel/mealInfoList";
import { serviceCheckInfo } from "./membership_hotel/serviceCheckInfo";
import { otherMenuInfoList } from "./membership_hotel/otherMenuInfoList";
import { inputUserInfo } from "./membership_hotel/inputUserInfo";
import { inputRoomList } from "./membership_hotel/inputRoomList";
import { inputAccompanyInfo } from "./membership_hotel/inputAccompanyInfo";
import { membershipSearchParam } from "./membership_hotel/membershipSearchParam";
import { membershipReserveInfo } from "./membership_hotel/membershipReserveInfo";
import { restaurantInfo } from "./membership_hotel/restaurantInfo";
import { resvKaiinken } from "./membership_hotel/resvKaiinken";
import { membershipResvStartDate } from "./membership_hotel/membershipResvStartDate";
import { estheticInfo } from "./membership_hotel/estheticInfo";
import { estheRsvInfo } from "./membership_hotel/estheRsvInfo";
import { restaurantReserveInfo } from "./membership_hotel/restaurantReserveInfo";
import { importedReserveComf } from "./membership_hotel/importedReserveComf"
import { crawlMember } from "./membership_hotel/crawlMember";
import { crawlOpenInfo } from "./membership_hotel/crawlOpenInfo";
import { vacancyWeek } from "./membership_hotel/vacancyWeek";
import { membershipCancelReserveComf } from "./membership_hotel/membershipCancelReserveComf";
import { overnightFlg } from "./membership_hotel/overnightFlg";
import { prevScreenInfo } from "./membership_hotel/prevScreenInfo";
import { golfLocation } from "./golfLocation";
import { riyobiList } from "./membership_hotel/riyobiList";

const AppReducer = combineReducers({
    login,
    playDate1,
    playDate2,
    detailCondition,
    favoriteCondition,
    course,
    startTime,
    group,
    searchResult,
    facility,
    plan,
    inputPlayer,
    teeTimeList,
    reserver,
    courseNames,
    version,
    reserveGolfCancelInfo,
    viewinfo,
    reserveType,
    kaiinken,
    reserveCheckInfo,
    changeReserveNo,
    ownerChecked,
    envParam,
    golfLocation,
    golfReservationCheck,
    golfReservationSearch,
    golfReservationList,
    // ゴルフ1人予約
    soloCourse,
    soloKaiinken,
    golfSoloSearchData,
    golfSoloTeetime,
    golfSoloReserveInfo,
    // RTCC
    checkIn,
    checkOut,
    keyWord,
    area,
    dispArea,
    country,
    dispCountry,
    city,
    dispCity,
    roomHome,
    roomOverseas,
    dispRoom,
    human,
    dispHuman,
    stayInfo,
    feeInfo,
    age,
    searchParam,
    catalogFlg,
    rtccFlg,
    passportInfo,
    toUserInputInfo,
    toUserInputConfirmInfo,
    inputFlightInfo,
    reserveInfo,
    reserveCancelInfo,
    customerAge,
    propertyInfo,
    // カタログ
    news,
    // 会員制ホテル
    room,
    adultNum,
    childNum,
    grade,
    roomDetailCriteria,
    dispFacility,
    dispDetailCondition,
    planConditions,
    privilegedService,
    food,
    membershipFacility,
    vacancyList,
    vacancyFacility,
    right,
    membershipReserveComf,
    mealInfoList,
    serviceCheckInfo,
    otherMenuInfoList,
    inputUserInfo,
    inputRoomList,
    inputAccompanyInfo,
    membershipSearchParam,
    membershipReserveInfo,
    restaurantInfo,
    resvKaiinken,
    membershipResvStartDate,
    estheticInfo,
    estheRsvInfo,
    restaurantReserveInfo,
    importedReserveComf,
    crawlMember,
    crawlOpenInfo,
    vacancyWeek,
    gradeData,
    membershipCancelReserveComf,
    overnightFlg,
    prevScreenInfo,
    riyobiList
});
const rootReducer = (state, action) => {
    if (action.type === "CLEAR_STATE") {
        console.log('初期化処理実行');
        state = undefined
    }
    return AppReducer(state, action)
}
export default rootReducer;